export interface AiReportGeneration {
    id: string;
    household_id: string;
    status: 'queued' | 'running' | 'completed' | 'failed' | 'uncertain';
    phase: 'waiting' | 'preparing' | 'generating' | 'finalizing' | null;
    period: { start_date: string; end_date: string };
    created_at: string;
    completed_at: string | null;
    report_id: string | null;
    report_url: string | null;
    error_code: string | null;
    can_retry: boolean;
    retry_kind: 'resume' | 'new_request' | null;
}
export const isActiveGeneration = (item: AiReportGeneration) =>
    item.status === 'queued' || item.status === 'running';
